import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import idx from 'idx';
import partial from 'lodash/partial';
import {
  updateParticipant, removeParticipant, resendInvite, toggleAddParticipantsModal
} from 'presentations/ducks';
import Participants from 'presentations/components/participants';

const mapStateToProps = (state) => {
  return {
    presentation: state.project.presentations.currentPresentation,
    participants: idx(state, _ => _.project.presentations.currentParticipants) || [],
  };
}

const mapDispatchToProps = (dispatch, { params }) => {
  const { presentationId } = params;

  return bindActionCreators({
    update: partial(updateParticipant, presentationId),
    remove: partial(removeParticipant, presentationId),
    resendInvite: partial(resendInvite, presentationId),
    toggleAddModal: toggleAddParticipantsModal
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Participants));



// WEBPACK FOOTER //
// ./presentations/containers/participants.js